export default "__VITE_ASSET__Dgm_3FRl__"